import Swal from "sweetalert2";

// Confirmación de borrado: botón rojo, foco en "Cancelar" (un Enter apurado no borra) y aviso
// de que no se puede deshacer. En la API el borrado es lógico (Activo = false), pero el visor
// nunca muestra lo inactivo: para el usuario no hay vuelta atrás.
export const confirmarBorrado = async ({ titulo, html }) => {
  const r = await Swal.fire({
    icon: "warning",
    title: titulo,
    html:
      html +
      '<div class="swal-aviso-irreversible"><i class="fas fa-triangle-exclamation me-2"></i>' +
      "Esta acción <b>no se puede deshacer</b> desde el visor.</div>",
    showCancelButton: true,
    confirmButtonText: "Sí, borrar",
    cancelButtonText: "Cancelar",
    focusCancel: true,
    reverseButtons: true,
    customClass: { confirmButton: "swal-peligro" },
  });
  return r.isConfirmed;
};
